import S3 from 'aws-sdk/clients/s3';
import pick from 'lodash/pick';

// FIX-ME: Move it to env config file
const AccessKey = 'ZAWKSKBMD3XUXOEMM52Y';
const SecretKey = 'ESeGTxrTpa90vXnhCJhYF7K56/5OkdDfwZrs5kchPPk';
const Bucket = 'tabiko';
const ImageFileSizeLimit = 12 * 1000 * 1000; // in Byte, so around 12MB
const S3Endpoint = 'https://sgp1.digitaloceanspaces.com';

/**
 * Initialize the AWS S3 SDK Instance
 */
const S3Bucket = new S3({
  endpoint: S3Endpoint,
  accessKeyId: AccessKey,
  secretAccessKey: SecretKey
});

export const Media = {
  methods: {
    /**
     * Prepend unique timestamp in filename to prevent
     * overwriting existing file with same name
     */
    createUniqueFilename: function(fileName, directory) {
      const uuid = require('uuid/v1');
      return `${directory}/${uuid()}-${fileName}`;
    },

    /**
     * Upload image to service provider
     * which return the url string of the image
     * @param {Object} file image object which want to be uploaded
     * @returns {Promise}
     */
    uploadImage: async function(file, directory = 'img-msgs') {
      return new Promise((resolve, reject) => {
        const { name, type, size } = file;
        if (size > ImageFileSizeLimit) {
          reject(new Error('Limit is exceed the size'));
        }

        const params = {
          Key: this.createUniqueFilename(name, directory),
          Bucket,
          ContentType: type,
          Body: file,
          ACL: 'public-read'
        };

        S3Bucket.putObject(params, function(error) {
          if (error) reject(error);

          const signedParams = pick(params, ['Key', 'Bucket']);
          const fullUrl = S3Bucket.getSignedUrl('getObject', signedParams);
          const url = fullUrl.split('?')[0];
          const response = { url, name, type, size };
          resolve(response);
        });
      });
    }
  }
};
